import { styled } from '@mui/system';
import { Grid } from '@mui/material';

const StyledMenuItems = styled(Grid)(({ theme }) => ({
    '.profile-links & .MuiButton-root': {
        backgroundColor: '#ffffff',
        border: '1px solid ' + theme.palette.blueButtons.main,
    },
    '.profile-links & .active, .profile-links & .MuiButton-root:hover': {
        backgroundColor: theme.palette.blueButtons.main,
    },
    '& .MuiButton-icon':{
        color: theme.palette.text.primary,
    }
}));
export default StyledMenuItems;